import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
    AlertCircle,
    CheckCircle,
} from "react-feather";
import { postData } from "../../utility/Utility";

const DESIGNATION_OPTIONS = [
    { value: "", label: "Select designation" },
    { value: "FIELD OFFICER", label: "Field Officer" },
    { value: "FIELD DEVELOPMENT OFFICER", label: "Field Development Officer" },
    { value: "SENIOR FIELD DEVELOPMENT OFFICER", label: "Senior Field Development Officer" },
    { value: "MANAGER", label: "Manager" },
    { value: "DIRECTOR", label: "Director" },
    { value: "OPERATIONAL DIRECTOR", label: "Operational Director" },
];

const DesignationEditModal = ({ show, onClose, currentDesignation = "", userData }) => {
    const navigate = useNavigate();
    const [designation, setDesignation] = useState(currentDesignation || "");
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);

    const validateForm = () => {
        if (!designation) {
            setError("Please select a designation");
            return false;
        }
        return true;
    };

    const handleSubmit = async () => {
        setError("");
        setSuccess("");

        if (!validateForm()) return;

        setIsSubmitting(true);

        try {
            // Direct API call in modal
            const response = await postData("api/admin/agent/update-designation", {
                agentId: userData?._id,
                designation,
            });

            if (response?.success) {
                setSuccess("Designation updated successfully!");

                setTimeout(() => {
                    onClose();
                    navigate("/user-management", { replace: true });
                }, 1500);
            } else {
                throw new Error(response?.message || "Failed to update designation");
            }
        } catch (err) {
            setError(err.message || "Failed to update designation. Please try again.");
        } finally {
            setIsSubmitting(false);
        }
    };

    if (!show) return null;

    return (
        <div
            className="modal show"
            style={{
                display: "block",
                backgroundColor: "rgba(0,0,0,0.5)",
            }}
            onClick={(e) => e.target === e.currentTarget && onClose()}
        >
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header bg-light">
                        <h5 className="modal-title d-flex align-items-center">
                            <i className="mdi mdi-briefcase me-2"></i>
                            Update Designation
                        </h5>
                        <button
                            type="button"
                            className="btn-close"
                            onClick={onClose}
                            disabled={isSubmitting}
                            aria-label="Close"
                        ></button>
                    </div>
                    <div className="modal-body">
                        {error && (
                            <div
                                className="alert alert-danger d-flex align-items-center"
                                role="alert"
                            >
                                <AlertCircle className="flex-shrink-0 me-2" size={18} />
                                <div>{error}</div>
                            </div>
                        )}

                        {success && (
                            <div
                                className="alert alert-success d-flex align-items-center"
                                role="alert"
                            >
                                <CheckCircle className="flex-shrink-0 me-2" size={18} />
                                <div>{success}</div>
                            </div>
                        )}

                        <div className="mb-4">
                            <label className="form-label fw-semibold">
                                Current Designation <span className="text-danger">*</span>
                            </label>
                            <select
                                className={`form-select ${!designation && "is-invalid"}`}
                                value={designation}
                                onChange={(e) => {
                                    setDesignation(e.target.value);
                                    setError("");
                                }}
                                disabled={isSubmitting}
                            >
                                <option value="">-- Select designation --</option>
                                {DESIGNATION_OPTIONS.map((option) => (
                                    <option key={option.value} value={option.value}>
                                        {option.label}
                                    </option>
                                ))}
                            </select>
                            {!designation && (
                                <div className="invalid-feedback">
                                    Please select a designation
                                </div>
                            )}
                        </div>

                        <div className="alert alert-info" role="alert">
                            <i className="mdi mdi-information-outline me-2"></i>
                            <small>
                                Updating the designation will change the user's role title and permissions
                                associated with the new designation.
                            </small>
                        </div>
                    </div>
                    <div className="modal-footer bg-light">
                        <button
                            type="button"
                            className="btn btn-outline-secondary"
                            onClick={onClose}
                            disabled={isSubmitting}
                        >
                            <i className="mdi mdi-close-circle-outline me-1"></i>
                            Cancel
                        </button>
                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={handleSubmit}
                            disabled={isSubmitting || !designation}
                        >
                            {isSubmitting ? (
                                <>
                                    <span
                                        className="spinner-border spinner-border-sm me-2"
                                        role="status"
                                        aria-hidden="true"
                                    ></span>
                                    Updating...
                                </>
                            ) : (
                                <>
                                    <i className="mdi mdi-content-save-check me-1"></i>
                                    Update Designation
                                </>
                            )}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DesignationEditModal;
